import EDDom from "../handler/EDDom.js"

export default class EDDiv extends EDDom {

    constructor(p) {

        p.tagName = "div"
        super(p)

        if(p.role) {
            this.attrib.add(
                "role",
                p.role
            )
        }
    }
}